import React, { useState } from "react";
import Login from "./Components/Login";
//import Dashboard from "./Components/Dashboard";
import Attendance from "./Components/attendance";
function App() {
  return <Attendance />;
}

export default App;
